export enum NotificationType {
  ALERT = 'alert',
  INFORMATION = 'information',
  CONFIRM = 'confirm'
}
